import { makeStyles, Theme } from '@material-ui/core';

type StylesProps = {
  isExpanded?: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: ({ isExpanded }: StylesProps) => ({
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: isExpanded ? 'none' : `1px solid ${theme.palette.gray[300]}`,
    padding: theme.spacing(0.75),
    paddingRight: theme.spacing(1.5),
    borderRadius: 0,
    '&:hover': {
      background: 'none',
    },
  }),
}));

export default useStyles;
